export default "__VITE_ASSET__mEqL1SxA__"